import { gql } from '@apollo/client'
import { HEALTH_DATA_REPORT_FIELDS } from '@screens/Nora/graphql/fragments/health_data_report.ts'

export const GENERATE_HEALTH_DATA_REPORT = gql`
  ${HEALTH_DATA_REPORT_FIELDS}
  mutation generateHealthDataReport(
    $kind: HealthDataReportKind!
    $startDate: ISO8601DateTime
    $endDate: ISO8601DateTime
    $focusAreas: [HealthDataReportFocusArea!]
  ) {
    generateHealthDataReport(
      kind: $kind
      startDate: $startDate
      endDate: $endDate
      focusAreas: $focusAreas
    ) {
      ...HealthDataReportFields
    }
  }
`
